// extracted by mini-css-extract-plugin
export default {"Login":"Login_Login__B-0At","link":"Login_link__eGL5Q"};